module.exports = __webpack_public_path__ + "img/card.28ba74ea.svg";